/*
 * pzz-recently-viewed-products.js
 * ---------------------------------------------------------------------------
 * Single storage authority for the PZZ "recently viewed" feature.
 *
 * Stores product HANDLES (most-recent first) under ONE key, capped at MAX.
 * Exposed as a global (window.PZZRecentlyViewed) so both the tracker snippet
 * and the section script share one contract — no ES-module/importmap setup,
 * and no duplicated key strings that can drift out of sync.
 *
 * Load via pzz-load (head), e.g.:
 *   <script src="{{ 'pzz-recently-viewed-products.js' | asset_url }}" defer></script>
 * Consumers gate their work on DOMContentLoaded, so load order is safe whether
 * this is deferred or not — just don't load it with `async`.
 * ---------------------------------------------------------------------------
 */
(function () {
  var KEY = 'pzz:recently-viewed';
  var MAX = 20;

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* private mode / storage disabled — fail silently */
    }
  }

  window.PZZRecentlyViewed = {
    KEY: KEY,
    MAX: MAX,

    /** @returns {string[]} stored handles, newest first */
    get: function () {
      return read();
    },

    /** Record a product view. @param {string} handle */
    add: function (handle) {
      if (!handle) return;
      var list = read().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      write(list);
    },

    /** Drop one or more handles (e.g. products that no longer resolve).
     *  @param {string|string[]} handles */
    remove: function (handles) {
      if (!handles) return;
      var drop = [].concat(handles);
      if (!drop.length) return;
      write(read().filter(function (h) { return drop.indexOf(h) === -1; }));
    },

    clear: function () {
      try { localStorage.removeItem(KEY); } catch (e) {}
    }
  };
})();